import styled from "styled-components";
import { spacing, opacity, ArrowDropdownDown } from "@conserveit/blocks";
import {
  $Menu,
  $ButtonItem,
  $MenuTitle,
} from "../../../components/Menu/Menu.styles";
import { TYPOGRAPHY } from "../../../components/AppChrome/App.constants";

// SELECT ELEMENTS
// ---------------

const $Select = styled.div`
  display: inline-block;
  position: relative;
`;

$Select.label = styled.button.attrs({ type: "button" })`
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  border: none;
  background: none;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;

  &:focus {
    outline: 0;
  }

  .Label-text {
    display: block;
  }
`;

$Select.triangle = styled(ArrowDropdownDown)`
  margin-left: ${spacing.extraTight};
`;

$Select.list = styled($Menu)`
  display: ${(props) => (props.isOpen ? "block" : "none")};
  left: auto;
  right: 0;
  top: 20px;
`;

$Select.option = styled($ButtonItem).attrs({ type: "button" })`
  font-weight: ${(props) =>
    props.isActive
      ? `${TYPOGRAPHY.WEIGHTS.BOLD}`
      : `${TYPOGRAPHY.WEIGHTS.REGULAR}`};
  padding: ${spacing.tight} ${spacing.snug};
  width: 100%;

  span {
    margin-right: ${spacing.tight};
  }

  label > span {
    flex-grow: 1;
  }

  &:disabled {
    opacity: ${opacity.subdued};

    span {
      cursor: default;
    }
  }
`;

$Select.title = $MenuTitle;

export { $Select };
